import {Select} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {setColorId} from "../../redux/slices/selectColor";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import {FETCH_PRODUCT_LIST} from "../../redux/actions";

const ColorSelectSearch = ({defaultValue , options }) => {

    const { t } = useTranslation()


    const dispatch = useDispatch();
    const {selectColor} = useSelector((state) => state.selectColor);

    const selectedColor = options?.find((color) => color.id === selectColor) || defaultValue;


    let switchValue =
        selectColor ?
        <div style={{display: "flex", alignItems: "center"}}>
            <div
                style={{
                    width: 20,
                    height: 20,
                    backgroundColor: selectedColor.color,
                    borderRadius: "50%",
                    marginRight: 8,
                    border: "1px solid #ccc",
                }}
            />
            <span>{selectedColor.name}</span>
        </div>
        :
        <span>{t('search.color')}</span>

    const handleChangeSelect = (id) => {
        dispatch(setColorId(id));
        dispatch({ type: FETCH_PRODUCT_LIST });
    }




    return (

        <Select
        style={{width:'100%'}}

            placeholder={t('search.color')}
            defaultValue={defaultValue}
            value={{
                value: selectedColor.id,
                label: switchValue,
            }}
            onChange={handleChangeSelect}
            options={options?.map((color) => ({
                value: color.id, // Pass ID as value
                label: (
                    <div style={{display: "flex", alignItems: "center"}}>
                        <div
                            style={{
                                width: 14,
                                height: 14,
                                backgroundColor: color.color,
                                borderRadius: "50%",
                                marginRight: 8,
                                border: "none",
                            }}
                        />
                        <span>{color.name}</span>
                    </div>
                ),
            }))}
        />

    )
}


export default ColorSelectSearch
